export default __webpack_public_path__ + "static/media/financialsituation3Img1.58476ae4.png";